import { 
  processMarkdownSection, 
  processInlineMarkdown
} from "@/lib/jobDetailsUtils";

interface JobDescriptionProps {
  description: string;
  showTitle?: boolean;
  titleClassName?: string;
  containerClassName?: string;
}

export function JobDescription({ 
  description, 
  showTitle = true,
  titleClassName = "text-lg font-semibold text-gray-900",
  containerClassName = "space-y-4"
}: JobDescriptionProps) {
  return (
    <div className={containerClassName}>
      {showTitle && (
        <h3 className={titleClassName}>Job Description</h3>
      )}
      <div className="space-y-4">
        {description.split('\n\n').map((section, index) => {
          const processed = processMarkdownSection(section, index);
          if (!processed) return null;

          switch (processed.type) {
            case 'h1':
              return (
                <h1 key={processed.key} className="text-lg font-bold text-gray-900 mb-3 break-words">
                  {processed.content}
                </h1>
              );
            case 'h2':
              return (
                <h2 key={processed.key} className="text-base font-semibold text-gray-900 mb-2 mt-4 break-words">
                  {processed.content}
                </h2>
              );
            case 'list':
              return (
                <ul key={processed.key} className="list-disc space-y-1 mb-3 ml-6">
                  {processed.items?.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-sm text-gray-700 break-words">
                      <span dangerouslySetInnerHTML={{
                        __html: processInlineMarkdown(item)
                      }} />
                    </li>
                  ))}
                </ul>
              );
            case 'paragraph':
              return (
                <p key={processed.key} className="text-sm text-gray-700 leading-relaxed mb-3 break-words whitespace-pre-wrap">
                  <span dangerouslySetInnerHTML={{
                    __html: processInlineMarkdown(processed.content || '')
                  }} />
                </p>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
}
